export const CrossIcon = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="#2C2C2C" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.1829 28.001L19.728 22.5462L14.2732 28.001L12.4549 26.1827L17.9098 20.7279L12.4549 15.2731L14.2732 13.4548L19.728 18.9096L25.1829 13.4548L27.0011 15.2731L21.5463 20.7279L27.0011 26.1827L25.1829 28.001Z" />
  </svg>
);

export const RefreshIcon = (
  <svg
    width="24"
    height="24"
    stroke="#2c2c2c"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.1538 5L16.8461 7.69231L14.1538 10.3846" strokeWidth="2" strokeLinecap="square" />
    <path
      d="M5 10.9231V7.69229H16.3077M9.84615 19L7.15385 16.3077L9.84615 13.6154"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path d="M19.0001 13.0769V16.3077H7.69238" strokeWidth="2" strokeLinecap="square" />
  </svg>
);
